module.exports = __webpack_public_path__ + "static/media/hamburger-svg.d1286606.png";